import { useEffect } from 'react'

import { TrackContentVisit, TrackContentVisitVariables } from 'globalTypes'

import { useMutation } from '@apollo/client'
import { useCurrentIp } from 'lib/use-current-ip'

import TRACKING_MUTATION from './track-content-visit.graphql'

interface Props {
  id: string
}

const VisitTracker = ({ id }: Props) => {
  const ip = useCurrentIp()
  const [mutate] = useMutation<TrackContentVisit, TrackContentVisitVariables>(
    TRACKING_MUTATION
  )

  useEffect(() => {
    mutate({
      variables: {
        id,
        ip,
      },
    })
  }, [id, ip, mutate])

  return null
}

export default VisitTracker
